export default __webpack_public_path__ + "static/media/PopupIcons_Notes_Grey.eaa0c128.svg";